module.exports = __webpack_public_path__ + "img/download-play-store.ee14c5a6.webp";